<template>
    <div class="modal fade" id="couponAddModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered  w-[500px] ">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5">Add New Coupon</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body ">
                    <div>
                        <div class="float-left w-full py-2 h-20 modal-item">
                            <v-checkbox v-model="isTest" label="Mark as Test Coupon (free trial proxy)" hide-details></v-checkbox>
                            <p v-if="isTest" class="text-[11px] text-gray-500 px-2">
                                Free for the trial length, once per customer, one proxy per use. On GlobalProxies stock the
                                hub's hourly plan is bought for those hours (we pay the hub's hourly price).
                            </p>
                        </div>
                        <div class="float-left w-1/2 px-2 py-2 h-20 modal-item">
                            Coupon Code:
                            <v-text-field v-model="couponCode" variant="outlined" density="compact" rounded="0">
                                <template v-slot:append-inner>
                                    <v-icon icon="mdi-refresh" class=" cursor-pointer"
                                        @click="generateCouponCode(6)"></v-icon>
                                </template>
                            </v-text-field>
                        </div>
                        <div class="float-left w-1/2 px-2 py-2 h-20 modal-item">
                            Expire Date:
                            <VueDatePicker v-model="expireDate" format='dd/MM/yyyy' :enable-time-picker="false">
                            </VueDatePicker>
                        </div>
                        <div class="float-right w-full flex px-2 h-[2rem] text-right modal-item gap-x-2 justify-end">
                            <v-icon icon="mdi-minus" class=" cursor-pointer" @click="minusYear"></v-icon>
                            1 year
                            <v-icon icon="mdi-plus" class=" cursor-pointer" @click="addYear"></v-icon>
                        </div>
                        <div class="w-full float-left px-2 py-2 h-20 modal-item" v-if="!isTest">
                            Discount Type:
                            <div>
                                <v-btn-toggle v-model="discountType" color="deep-purple-accent-3" group mandatory
                                    rounded="0" style="height: 40px;" class="border w-full">
                                    <v-btn value="percentage" class="w-1/2 bg-white text-black h-full"
                                        style="outline: none; height: 100%;">
                                        <p class="sm:text-xs text-[10px]">Percentage discount</p>
                                    </v-btn>
                                    <v-btn value="flat" class="w-1/2 bg-white text-black h-full"
                                        style="outline: none; height: 100%;">
                                        <p class="sm:text-xs text-[10px]">Flat rate discount</p>
                                    </v-btn>
                                </v-btn-toggle>
                            </div>
                        </div>
                        <div class="w-1/2 float-left px-2 py-2 h-20 modal-item" v-if="!isTest">
                            Value:
                            <span v-if="discountType === 'percentage'">(%)</span>
                            <span v-else>($)</span>
                            <v-text-field v-model="discountValue" variant="outlined" density="compact" rounded="0"
                                type="number" style=""></v-text-field>
                        </div>
                        <div class="w-1/2 float-left px-2 py-2 h-20 modal-item" v-if="!isTest">
                            Coupon Type:
                            <div>
                                <v-btn-toggle v-model="couponType" color="deep-purple-accent-3" group mandatory
                                    rounded="0" style="height: 40px;" class="border w-full">
                                    <v-btn value="purchase" class="w-1/2 bg-white text-black h-full"
                                        style="outline: none; height: 100%;">
                                        <p class="text-xs">Purchase</p>
                                    </v-btn>
                                    <v-btn value="deposit" class="w-1/2 bg-white text-black h-full"
                                        style="outline: none; height: 100%;">
                                        <p class="text-xs">Deposits</p>
                                    </v-btn>
                                </v-btn-toggle>
                            </div>
                        </div>
                        <div class="w-1/2 float-left px-2 py-2 h-20 modal-item">
                            User:
                            <v-combobox v-model="selectedUserEmail" :items="customers" placeholder="Select" rounded="0"
                                variant="outlined" style="outline: none;" density="compact" :hide-no-data="false">
                                <template v-slot:no-data>
                                    <v-list-item density>
                                        <v-list-item-title density="compact" variant="disabled">
                                            <p class="text-sm text-gray-600 text-center">Not found</p>
                                        </v-list-item-title>
                                    </v-list-item>
                                </template>
                            </v-combobox>
                        </div>
                        <div v-if="couponType === 'purchase'"
                            class="w-1/2 float-left px-2 py-2 h-20 modal-item">
                            Package Price<span v-if="isTest"> (0 = any plan)</span>:
                            <v-text-field v-model="price" variant="outlined" density="compact" rounded="0" type="number"
                                style=""></v-text-field>
                        </div>
                        <div v-if="isTest" class="w-1/2 float-left px-2 py-2 h-20 modal-item">
                            Daily Limit:
                            <v-text-field v-model="dailyLimit" variant="outlined" density="compact" rounded="0"
                                type="number" style=""></v-text-field>
                        </div>
                        <div v-if="isTest" class="w-1/2 float-left px-2 py-2 h-20 modal-item">
                            Trial length (hours, 2-4):
                            <v-text-field v-model="trialHours" variant="outlined" density="compact" rounded="0"
                                type="number" min="2" max="4" style=""></v-text-field>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" :disabled="buttonDisableFlag" class="btn btn-primary"
                        @click="handleCreate">Create</button>
                </div>
            </div>
        </div>
    </div>
</template>


<script setup>
import { ref, watch, watchEffect, defineEmits } from 'vue';
import { useAdminLicenseStore, useAdminCouponStore } from "@/stores"
import VueDatePicker from '@vuepic/vue-datepicker';
import { storeToRefs } from 'pinia';
import { format } from 'date-fns';

const adminLicenseStore = useAdminLicenseStore();
const adminCouponStore = useAdminCouponStore();


const { customers } = storeToRefs(adminLicenseStore)

adminLicenseStore.getCustomers()

const buttonDisableFlag = ref(false);
const couponCode = ref('');
const expireDate = ref(new Date());
expireDate.value.setFullYear(expireDate.value.getFullYear() + 3);
const discountType = ref('percentage');
const discountValue = ref(0);
const couponType = ref('purchase');
const selectedUserEmail = ref('All');
const price = ref(5)
const isTest = ref(false)
const dailyLimit = ref(2)
const trialHours = ref(2)
// a trial is usually offered on any plan: "Package Price" 0 = every plan
watch(isTest, (on) => { if (on && Number(price.value) === 5) price.value = 0; else if (!on && Number(price.value) === 0) price.value = 5 })
const emit = defineEmits(['inInput', 'submit'])

const handleCreate = () => {
    let packageRequest = {
        couponCode: couponCode.value,
        expireDate: format(expireDate.value, 'dd/MM/yyyy'),
        discountType: discountType.value,
        discountValue: discountValue.value,
        couponType: couponType.value,
        user: selectedUserEmail.value,
        price: price.value
    };

    if (isTest.value) {
        packageRequest.discountType = 'percentage';
        packageRequest.discountValue = 100;
        packageRequest.couponType = 'purchase';
        packageRequest.price = price.value;
        packageRequest.dailyLimit = dailyLimit.value;
        packageRequest.trialHours = trialHours.value;
    }

    // const file = fileInput.value.$el.querySelector('input').files[0];
    // formData.append('file', file);

    buttonDisableFlag.value = true;
    // Send FormData to server
    adminCouponStore.createNewCoupon(packageRequest).then(() => {
        adminCouponStore.loadCoupons();
        buttonDisableFlag.value = false;
        emit('close');
    });
};

const minusYear = () => {
    const newDate = new Date(expireDate.value);
    newDate.setFullYear(newDate.getFullYear() - 1);
    expireDate.value = newDate;
}

const addYear = () => {
    const newDate = new Date(expireDate.value);
    newDate.setFullYear(newDate.getFullYear() + 1);
    expireDate.value = newDate;
}

function generateCouponCode(length) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'; // Allowed characters
    let tempCouponCode = '';

    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        tempCouponCode += characters[randomIndex];
    }

    couponCode.value = tempCouponCode;
}

</script>
